import { createI18n } from 'vue-i18n'
import locales from '@/locales'
import { appMode } from '../config/mode'

const { languages = [] } = globalThis.navigator

const i18n = createI18n({
  legacy: false,
  locale: languages.find((locale) => _.keys(locales).includes(locale)) || import.meta.env.VUE_APP_DEFAULT_LANG,
  fallbackLocale: import.meta.env.VUE_APP_DEFAULT_LANG,
  fallbackRoot: true,
  sync: true,
  fallbackWarn: false,
  missingWarn: false,
  messages: locales,
  warnHtmlMessage: false,
  missing (_locale, key) {
    // Special case for title, we don't want to warn about it
    if (key === 'title' || key.startsWith('title.')) {
      return
    }
    if (!appMode.isProduction) {
      console.warn(`error: missing locale ${_locale}.${key}`)
    }
  },
})

export default i18n
